import { render, staticRenderFns } from "./HubLeaderboard.vue?vue&type=template&id=33537da2&scoped=true"
import script from "./HubLeaderboard.vue?vue&type=script&lang=js"
export * from "./HubLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./HubLeaderboard.vue?vue&type=style&index=0&id=33537da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33537da2",
  null
  
)

export default component.exports